import React, { useEffect, useState } from "react";
import { DebounceInput } from "react-debounce-input";
import ReactPaginate from "react-paginate";
import Select from "react-select";

import { PGET, GET, excelParams } from "../../../api/adminApi";

function formatDate(value) {
    if (!value) return "-";
    const str = String(value).replace("T", " ");
    return str.length > 16 ? str.substring(0, 16) : str;
}

function StatCard({ label, value, color }) {
    return (
        <div
            style={{
                background: "#fff",
                borderRadius: 14,
                padding: "12px 16px",
                minWidth: 130,
                flex: "1 1 130px",
                boxShadow: "0 2px 10px rgba(0,0,0,.04)",
                borderTop: `3px solid ${color}`,
            }}
        >
            <div style={{ fontSize: 22, fontWeight: 800, color: "#1B1B1F" }}>
                {value ?? 0}
            </div>
            <div style={{ fontSize: 12, color: "#6B6B72", marginTop: 2 }}>{label}</div>
        </div>
    );
}

function HeatingMasters() {
    const [items, setItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [value, setValue] = useState("");
    const [regions, setRegions] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [summary, setSummary] = useState({});
    const [currentPage, setCurrentPage] = useState(
        +localStorage.getItem("currentPageHeatingMasters") || 0
    );

    const regionId = selectedRegion && selectedRegion.id ? selectedRegion.id : null;

    const handleSearchInput = (e) => {
        setValue(e.target.value);
        setCurrentPage(0);
        localStorage.setItem("currentPageHeatingMasters", 0);
    };

    function handleRegionChange(option) {
        setSelectedRegion(option);
        setCurrentPage(0);
        localStorage.setItem("currentPageHeatingMasters", 0);
    }

    function paginate(data) {
        setCurrentPage(data.selected);
        localStorage.setItem("currentPageHeatingMasters", data.selected);
    }

    async function getRegions() {
        const data = await GET("/services/admin/api/region-helper/1", false);
        setRegions([{ id: 0, name: "Все регионы" }, ...(data || [])]);
    }

    async function getItems() {
        const payload = { page: currentPage, size: 10, search: value };
        if (regionId) payload.region = regionId;
        const data = await PGET("/services/admin/api/heating-master-stats-pageList", true, payload);
        setPageCount(Math.ceil(data.headers["x-total-count"] / 10));
        setItems(data.data);
    }

    async function getSummary() {
        const url =
            "/services/admin/api/heating-stats-summary" + (regionId ? "?region=" + regionId : "");
        const data = await GET(url, false);
        setSummary(data || {});
    }

    function exportExcel() {
        const payload = { search: value };
        if (regionId) payload.region = regionId;
        excelParams(
            "/services/admin/api/heating-master-stats-download",
            "teplokalkulyator-masters.xlsx",
            true,
            payload
        );
    }

    useEffect(() => {
        getRegions();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        getItems();
        getSummary();
    }, [currentPage, value, selectedRegion]); // eslint-disable-line react-hooks/exhaustive-deps

    const headStyle = { backgroundColor: "#E7372C", fontWeight: "700" };

    return (
        <div
            className="br-5 card"
            style={{ background: "#eef1ff", marginTop: "-0.9rem", height: "100vh" }}
        >
            <div className="card-header border-0 pt-5">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold fs-3 mb-1">
                        Мастера — теплотехнический калькулятор
                    </span>
                </h3>
            </div>
            <div className="px-3 pb-4 pt-2">
                {/* Statistika kartalari */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
                    <StatCard label="Всего мастеров" value={summary.totalMasters} color="#1d4ed8" />
                    <StatCard label="Активны 7 дней" value={summary.active7} color="#16a34a" />
                    <StatCard label="Активны 30 дней" value={summary.active30} color="#16a34a" />
                    <StatCard label="Новые (30 дней)" value={summary.new30} color="#0891b2" />
                    <StatCard label="Не исп. 30+ дней" value={summary.inactive30} color="#f59e0b" />
                    <StatCard label="Не исп. 60+ дней" value={summary.inactive60} color="#ea580c" />
                    <StatCard label="Не исп. 90+ дней" value={summary.inactive90} color="#dc2626" />
                    <StatCard label="Проектов" value={summary.totalProjects} color="#6b7280" />
                    <StatCard label="Комнат" value={summary.totalRooms} color="#6b7280" />
                </div>

                <div className="mb-4 d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                    <div className="d-flex align-items-center" style={{ gap: 12 }}>
                        <div className="position-relative">
                            <DebounceInput
                                minLength={3}
                                debounceTimeout={400}
                                value={value}
                                onChange={handleSearchInput}
                                type="text"
                                className="input-search search-icon br-5"
                                size={24}
                                placeholder="Поиск (ФИО, телефон)"
                            />
                        </div>
                        <div style={{ minWidth: 220 }}>
                            <Select
                                options={regions}
                                getOptionLabel={(o) => o.name}
                                getOptionValue={(o) => o.id}
                                value={selectedRegion}
                                onChange={handleRegionChange}
                                placeholder="Регион"
                                isClearable
                            />
                        </div>
                    </div>
                    <button
                        onClick={exportExcel}
                        className="btn btn-sm btn-success"
                        style={{ fontWeight: 600 }}
                    >
                        📥 Excel
                    </button>
                </div>
                <div style={{ overflow: "auto", maxHeight: "62vh" }}>
                    <table className="table bg-white table-rounded p-0 border gy-4 gs-7">
                        <thead className="position-sticky top-0 rounded">
                            <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                                <th style={{ ...headStyle, borderTopLeftRadius: "8px", width: "30px" }} className="text-white text-center">№</th>
                                <th className="text-start text-white" style={headStyle}>Мастер</th>
                                <th className="text-start text-white" style={headStyle}>Телефон</th>
                                <th className="text-start text-white" style={headStyle}>Регион</th>
                                <th className="text-center text-white" style={headStyle}>Проектов</th>
                                <th className="text-center text-white" style={headStyle}>Комнат</th>
                                <th className="text-center text-white" style={headStyle}>Последний проект</th>
                                <th className="text-center text-white" style={headStyle}>Первый проект</th>
                                <th className="text-center text-white" style={{ ...headStyle, borderTopRightRadius: "8px" }}>Последняя активность</th>
                            </tr>
                        </thead>
                        <tbody style={{ overflowX: "auto" }}>
                            {items.map((item, idx) => (
                                <tr key={item.masterId} className="borderBottom">
                                    <td className="text-center">
                                        {currentPage === 0 ? idx + 1 : currentPage * 10 + idx + 1}
                                    </td>
                                    <td className="text-start">{item.masterFullName || "-"}</td>
                                    <td className="text-start">{item.masterPhone || "-"}</td>
                                    <td className="text-start">{item.region || "-"}</td>
                                    <td className="text-center">
                                        <span className="badge bg-primary">{item.totalProjects ?? 0}</span>
                                    </td>
                                    <td className="text-center">{item.totalRooms ?? 0}</td>
                                    <td className="text-center">{formatDate(item.lastCreated)}</td>
                                    <td className="text-center">{formatDate(item.firstCreated)}</td>
                                    <td className="text-center">{formatDate(item.lastActivity)}</td>
                                </tr>
                            ))}
                            {items.length === 0 && (
                                <tr>
                                    <td colSpan={9} className="text-center text-muted py-4">
                                        Нет данных
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {pageCount > 1 && (
                    <ReactPaginate
                        forcePage={currentPage}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={1}
                        onPageChange={paginate}
                        containerClassName={"pagination"}
                        activeClassName={"bg-dark text-white"}
                        pageClassName={"page-item box-shadow"}
                    />
                )}
            </div>
        </div>
    );
}

export default HeatingMasters;
